import { resolveCategories, resolveCategory, resolveNestedCategories } from './resolvers/categories.resolver';
import { resolveOptions, resolveOption } from './resolvers/options.resolver';
import { resolveDays } from '../days/resolvers/day.resolver';
import { resolveExtras, resolveExtra } from './resolvers/extras.resolver';
import { resolveTreatments } from '../treatment/resolvers/treatments.resolver';
import { resolveUpgrades } from './resolvers/upgrades.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.categories', {
            url: '/category',
            component: 'categoryList',
            resolve: {
                categories: resolveNestedCategories(),
                pagedcategories: resolveCategories(1, 20)
            },
            roles: ['manager']
        })
        .state('app.admin.deletedcategories', {
            url: '/category/deleted',
            component: 'categoryList',
            resolve: {
                pagedcategories: resolveCategories(1, 20, 'deleted')
            },
            roles: ['admin']
        })
        .state('app.admin.category-add', {
            url: '/category/create',
            component: 'categorySave',
            resolve: {
                title: () => 'Create a Category',
                category: resolveCategory(),
                treatments: resolveTreatments(-1),
                days: resolveDays(-1),
                categories: resolveNestedCategories('flatten')
            },
            roles: ['manager']
        })
        .state('app.admin.category-edit', {
            url: '/category/:category/update',
            component: 'categorySave',
            resolve: {
                title: () => 'Update a Category',
                category: resolveCategory(),
                treatments: resolveTreatments(-1),
                days: resolveDays(-1),
                categories: resolveNestedCategories('flatten')
            },
            roles: ['manager']
        })
        .state('app.admin.extras', {
            url: '/extras?:filtertext',
            component: 'extrasList',
            resolve: {
                extras: resolveExtras(1, 20)
            },
            roles: ['manager']
        })
        .state('app.admin.deletedextras', {
            url: '/extras/deleted',
            component: 'extrasList',
            resolve: {
                extras: resolveExtras(1, 20, 'deleted')
            },
            roles: ['admin']
        })
        .state('app.admin.extra-add', {
            url: '/extras/create',
            component: 'extrasSave',
            resolve: {
                title: () => 'Create an Extra',
                extra: resolveExtra(),
            },
            roles: ['manager']
        })
        .state('app.admin.extra-edit', {
            url: '/extras/:extra/update?tab',
            component: 'extrasSave',
            resolve: {
                title: () => 'Update an Extra',
                extra: resolveExtra()
            },
            roles: ['manager']
        })
        .state('app.admin.options', {
            url: '/option?:filtertext',
            component: 'optionsList',
            resolve: {
                options: resolveOptions(1, 20)
            },
            roles: ['manager']
        })
        .state('app.admin.deletedoptions', {
            url: '/option/deleted',
            component: 'optionsList',
            resolve: {
                options: resolveOptions(1, 20, 'deleted')
            },
            roles: ['admin']
        })
        .state('app.admin.option-add', {
            url: '/option/create',
            component: 'optionsSave',
            resolve: {
                title: () => 'Create an Option',
                option: resolveOption(),
                treatments: resolveTreatments(-1),
                days: resolveDays(-1),
            },
            roles: ['manager']
        })
        .state('app.admin.option-edit', {
            url: '/option/:option/update?tab',
            component: 'optionsSave',
            resolve: {
                title: () => 'Update an Option',
                option: resolveOption(),
                treatments: resolveTreatments(-1),
                days: resolveDays(-1),
            },
            roles: ['manager']
        })
        .state('app.admin.upgrades', {
            url: '/upgrades',
            component: 'upgradesList',
            resolve: {
                spadays: resolveDays(-1),
                treatments: resolveTreatments(-1),
                upgrades: resolveUpgrades()
            },
            roles: ['manager']
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/event.routes.js